var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0V12L3.51468 20.4853C5.68626 22.6568 8.68626 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 12 0 12 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.68626 0 5.68626 1.34316 3.51468 3.51469C6.4589 6.45891 7.50407 7.50412 12 12H24C24 5.37262 18.6274 0 12 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21677 12L6.75127 11.3107L7.53169 9.89134L5.94028 10.1958L5.73863 8.58812L4.63013 9.77049L3.52167 8.58812L3.31997 10.1958L1.72861 9.89129L2.50903 11.3107L1.04349 12L2.50903 12.6894L1.72861 14.1087L3.32011 13.8043L3.52163 15.4119L4.63013 14.2295L5.73863 15.4119L5.94028 13.8043L7.5316 14.1087L6.75122 12.6894L8.21677 12Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2003 4.69566L3.68799 5.37737L4.48697 5.12429L3.98925 5.79873L4.47694 6.48043L3.68166 6.21554L3.18399 6.88993L3.19022 6.0518L2.39499 5.78687L3.19411 5.53379L3.2003 4.69566Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2003 17.1101L3.68799 17.7918L4.48697 17.5387L3.98925 18.2132L4.47694 18.8949L3.68166 18.63L3.18399 19.3044L3.19022 18.4662L2.39499 18.2013L3.19411 17.9482L3.2003 17.1101Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 10.9029L9.66857 11.5846L8.86954 11.3314L9.36726 12.0059L8.87957 12.6877L9.67485 12.4227L10.1726 13.0971L10.1663 12.259L10.9615 11.9941L10.1624 11.741L10.1562 10.9029Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/philippines.efd9b99a5c2d09fe7096ddde9991d746.svg";
export { ForwardRef as ReactComponent };